import { ERROR_CODES } from "score-common";

// Card #3253 (shared with #3249): the HELD-and-retry mechanism.
//
// Some score-api 4xx refusals are not a bad payload, they name a condition
// that CLEARS by itself once somebody else acts (the secretary captures a
// judge's signature in Score Admin). Shipping such an op to /quarantine and
// removing it (the permanent-4xx path in sync.js) loses the write silently:
// the local sheet already looks complete, the server sheet never gets
// completedAt, and nobody is told. A held op instead stays in the outbox,
// is NOT surfaced as a failure, and is re-tried on reconnect / hydrate /
// sign-in and on a slow timer until the condition clears.
//
// NAMING: "held" in db.js / outboxDetail.js (isHeldOp) already means "owned by
// a different signed-in scribe". This is a different thing, so the op field is
// `holdReason` and the Queue row state is WAITING. errorClass stays "held".
//
// To add a reason (card #3249): add a HOLD_REASONS value, map the server's
// failure `code` to it in HOLD_REASON_BY_CODE, and add its static i18n label
// in Queue.jsx / score.json. Nothing in sync.js changes.
export const HOLD_REASONS = Object.freeze({
  JUDGE_SIGNATURE: "judge_signature",
});

const KNOWN_REASONS = new Set(Object.values(HOLD_REASONS));

// Fallback keyed on the failure `code` alone, so a scribe-fe talking to a
// score-api that predates `data.holdReason` still holds instead of
// quarantining. score-api (lib/score-failure.js holdData) sends both.
const HOLD_REASON_BY_CODE = Object.freeze({
  [ERROR_CODES.MISSING_SIGNATURE]: HOLD_REASONS.JUDGE_SIGNATURE,
});

// Slow, FIXED cadence (not the exponential error backoff): the condition
// clears on a human's timescale and the retry is one cheap request.
export const HELD_RETRY_MS = 30_000;

// `body` is score-api's JSend fail body ({ status, code, data }), i.e.
// err.response.data.
export function holdReasonFromFailureBody(body) {
  const named = body?.data?.holdReason;
  if (typeof named === "string" && KNOWN_REASONS.has(named)) return named;
  const code = body?.code;
  return (code && HOLD_REASON_BY_CODE[code]) || null;
}

export function isWaitingOp(op) {
  return op?.status === "error" && op?.errorClass === "held" && !!op?.holdReason;
}
